import { responseErrorHandle } from '@/utils/utils';
import {
  checkPayoffUser,
  deletePayee,
  downloadFailFile,
  exportBankCardOuterUserCheckResult,
  getBankCardOuterUserCheckResult,
  getBankList,
  getInstitutionUserList,
  getPayoffUserDetail,
  getPayoffUserList,
  getPersonnelNature,
  getTemplate,
  savePayoffUser,
  setPayoffUserState,
  surePayoffUser,
  uploadTemplate,
} from '../services/index';

export default {
  namespace: 'payeeManage',
  state: {
    bankList: [],
    personnelNatureList: [],
  },
  effects: {
    // 删除发放对象
    *deletePayee({ payload }, { call }) {
      try {
        const res = yield call(deletePayee, payload);
        responseErrorHandle(res);
        return res;
      } catch (e) {}
    },

    // 获取发放对象列表
    *getPayoffUserList({ payload }, { call }) {
      try {
        const res = yield call(getPayoffUserList, payload);
        responseErrorHandle(res);
        return res;
      } catch (e) {}
    },

    // 获取匹配用户列表
    *getInstitutionUserList({ payload }, { call }) {
      const res = yield call(getInstitutionUserList, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取银行列表
    *getBankList({ payload }, { call, put }) {
      const res = yield call(getBankList, payload);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          bankList: res?.result || [],
        },
      });
      return res;
    },

    // 获取人员性质列表
    *getPersonnelNatureList({ payload }, { call, put }) {
      const res = yield call(getPersonnelNature, payload);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          personnelNatureList: res?.result || [],
        },
      });
      return res;
    },

    // 新增、编辑发放对象
    *savePayoffUser({ payload }, { call }) {
      const res = yield call(savePayoffUser, payload);

      return res;
    },

    // 新增、编辑用户唯一性验证接口
    *checkPayoffUser({ payload }, { call }) {
      const res = yield call(checkPayoffUser, payload);
      return res;
    },

    // 下载模板
    *getTemplate({ payload }, { call }) {
      const res = yield call(getTemplate, payload);
      responseErrorHandle(res);
      return res;
    },

    // 上传模板
    *uploadTemplate({ payload }, { call }) {
      const res = yield call(uploadTemplate, payload);
      return res;
    },

    // 获取方法对象详情
    *getPayoffUserDetail({ payload }, { call }) {
      const res = yield call(getPayoffUserDetail, payload);
      responseErrorHandle(res);
      return res;
    },

    // 启用、停用发放对象
    *setPayoffUserState({ payload }, { call }) {
      const res = yield call(setPayoffUserState, payload);
      responseErrorHandle(res);
      return res;
    },

    // 下载失败文件
    *downloadFailFile({ payload }, { call }) {
      const res = yield call(downloadFailFile, payload);

      return res;
    },

    // 批量确认发放对象
    *surePayoffUser({ payload }, { call }) {
      const res = yield call(surePayoffUser, payload);
      responseErrorHandle(res);
      return res;
    },
    *exportBankCardOuterUserCheckResult({ payload }, { call }) {
      const result = yield call(exportBankCardOuterUserCheckResult, payload);
      return result;
    },

    *getBankCardOuterUserCheckResult({ payload }, { call }) {
      const result = yield call(getBankCardOuterUserCheckResult, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
